export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20inviting%20modern%20workspace%20with%20laptop%20displaying%20spreadsheet%20analytics%20and%20colorful%20data%20charts%20on%20screen%2C%20cozy%20desk%20setup%20with%20natural%20wood%20elements%20and%20soft%20ambient%20lighting%2C%20golden%20hour%20sunlight%20streaming%20through%20window%20casting%20gentle%20warm%20glow%2C%20peaceful%20productive%20atmosphere%2C%20elegant%20comfortable%20home%20office%20with%20plants%20and%20minimal%20decor%2C%20editorial%20lifestyle%20photography&width=1800&height=800&seq=cta-img-litbuy-2026-new&orientation=landscape"
          alt="Start organizing your LitBuy spreadsheet today"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/70 via-foreground-900/40 to-transparent"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-4xl">
          <div className="max-w-lg">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-background-50 mb-4 leading-tight">
              Ready to Get Started with LitBuy Spreadsheets?
            </h2>
            <p className="text-base text-background-50/80 mb-8 leading-relaxed max-w-md">
              Explore our complete collection of guides, templates, and tracking resources
              to transform your data management today.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center px-7 py-3 text-sm font-bold bg-background-50 text-foreground-900 rounded-full hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                Visit LitBuy Spreadsheet
                <span className="w-4 h-4 flex items-center justify-center ml-2">
                  <i className="ri-arrow-right-up-line text-sm"></i>
                </span>
              </a>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center px-7 py-3 text-sm font-bold border-2 border-background-50/60 text-background-50 rounded-full hover:bg-background-50/10 transition-colors cursor-pointer whitespace-nowrap"
              >
                Buy It Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}